import ky, { HTTPError } from "ky";
const apiBase = import.meta.env.VITE_API_BASE_URL || "/";
export const api = ky.extend({
    prefixUrl: apiBase,
    credentials: "include", // send cookies
    // CSRF defence: the backend requires a custom header on state-changing /api
    // requests. A cross-origin forged request cannot set this header without a
    // CORS preflight, which our CORS config only grants to allow-listed origins.
    // Sending it on every request keeps the SPA working (including the login POST).
    headers: { "X-Requested-With": "XMLHttpRequest" },
    retry: { limit: 2, methods: ["get"] },
    hooks: {
        afterResponse: [
            async (state) => {
                const response = state.response;
                if (response?.status === 401) {
                    window.dispatchEvent(new CustomEvent("sidecar:unauthenticated"));
                }
            },
        ],
    },
});
export async function unwrapError(err) {
    if (err instanceof HTTPError) {
        try {
            const body = (await err.response.json());
            return body.error ?? { code: "unknown", message: err.message };
        }
        catch {
            return { code: "unknown", message: err.message };
        }
    }
    return { code: "network_error", message: String(err) };
}
